import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const MOBILE_HOME = {
  nickname: 'PRODUCTS.MOBILE_HOME.nickname',
  properties: [
    { name: 'vehicleLicenceNumberAvailability', key: 'VEHICLE_LICENCE_NUMBER_AVAILABILITY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isLicenceNumberAvailabilityCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    {
      name: 'mobileHomeMark', key: 'WTC_MARK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    {
      name: 'mobileHomeModel', key: 'WTC_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'mobileHomeMarketValue', key: 'MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'mobileHomeTracker', key: 'WTC_TRACKER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'estimatedAnnualMileage', key: 'ESTIMATED_ANNUAL_MILAGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.8', value: 8000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.12', value: 12000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.16', value: 16000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ESTIMATED_ANNUAL_MILAGE.31', value: 'Ubegrenset' }
        ]
      }
    },
    {
      name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleDrivingLengthReadingDate', key: 'DRIVING_LENGTH_READING_DATE_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    },
    { name: 'vehicleAlarm', key: 'MOBILE_HOME_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.MOBILE_HOME_ALARM.NO_FUSE', value: 'NO_FUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.MOBILE_HOME_ALARM.ALARM', value: 'ALARM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.MOBILE_HOME_ALARM.IMMOBILIZER', value: 'IMMOBILIZER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.MOBILE_HOME_ALARM.ALARM_AND_IMMOBILIZER', value: 'ALARM_AND_IMMOBILIZER' }
        ]
      }
    },
    { name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-50', value: '-50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-40', value: '-40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-30', value: '-30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-20', value: '-20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.-10', value: '-10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70', value: '70' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_1', value: '70,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_2', value: '70,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_3', value: '70,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_4', value: '70,4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_5', value: '70,5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_4', value: '75,4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_5', value: '75,5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_6_wtc', value: '75,6' }
        ]
      }
    },
    {
      name: 'wtcMobileHomeExtraValuables', key: 'WTC_EXTRA_VALUABLES', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.0', value: 0 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.40', value: 40000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.50', value: 50000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.75', value: 75000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.100', value: 100000 }
        ]
      }
    },
    { name: 'deductible', key: 'WTC_VOLUNTARY_EXCESS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.50', value: 50000 },
        ]
      }
    },
    { name: 'mobileHomeWeight', key: 'MOBILE_HOME_WEIGHT', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ELITE', value: 'SUPER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'FIRE_AND_THEFT_STANDALONE' }
        ]
      }
    },
    { name: 'vehicleRescue', key: 'VEHICLE_REDNING', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleLeasing', key: 'VEHICLE_LEASING', group: 'INSURANCE_INFO',
      // isLisingCheck: true,
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    // { name: 'tfaAnnualFeeGroup', key: 'TFA_ANNUAL_FEE_GROUP', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.STRING,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    // { name: 'trafficInsuranceFee', key: 'TRAFFIC_INSURANCE_FEE', group: 'INSURANCE_INFO',
    //   inputType: INPUT_TYPES_CONFIG.STRING,
    //   validator: ['', [
    //     Validators.required
    //   ]]
    // },
    { name: 'tifGroup', key: 'TFA_ANNUAL_FEE_GROUP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHugeSelectContainer: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_000', value: 'GROUP_000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_100', value: 'GROUP_100' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_110', value: 'GROUP_110' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_200', value: 'GROUP_200' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_300', value: 'GROUP_300' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_400', value: 'GROUP_400' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_900', value: 'GROUP_900' }
        ]
      }
    },
    { name: 'zipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        TRAILER: {
          key: 'OBJECT_ZIP_TRAILER'
        }
      }
    },
  ],
  icon:'mobile-home'
};
